import { Box, List, ListItem, ListItemText, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 26,
  position: 'relative',
  '::before': {
    content: '""',
    position: 'absolute',
    left: 10,
    top: 12,
    backgroundColor: theme.palette.text.primary,
    borderRadius: '100%',
    width: 5,
    aspectRatio: '1 / 1',
  },
}));

const VoiceRecordInstruction = () => {
  const { t } = useTranslation();
  return (
    <Box mt={3}>
      <Typography>{t('assessment.question.voice.text_1')}</Typography>
      <List>
        <StyledListItem>
          <ListItemText>{t('assessment.question.voice.item_1')}</ListItemText>
        </StyledListItem>
        <StyledListItem>
          <ListItemText>{t('assessment.question.voice.item_2')}</ListItemText>
        </StyledListItem>
        <StyledListItem>
          <ListItemText>{t('assessment.question.voice.item_3')}</ListItemText>
        </StyledListItem>
        <StyledListItem>
          <ListItemText>{t('assessment.question.voice.item_4')}</ListItemText>
        </StyledListItem>
      </List>
    </Box>
  );
};
export default VoiceRecordInstruction;
